const environment = {
    api: 'https://api.resumejam.com/api',
    isProduction: true,
    isDevelopment: false,
    GOOGLE_MAPS_API_KEY: 'AIzaSyDepy97mrWVwB4KOzgZ0X4aUu9JN2ucKD4'
}

export default environment